import { ThanksIcon } from '@avila-tek/ui/src';
import Link from 'next/link';
import React from 'react';
import Badge from '../Badge';

interface ThanksProps {
  title: string;
  subtitle: string;
}

function Thanks({ title, subtitle }: ThanksProps) {
  return (
    <div className="w-full flex flex-col justify-center items-center ">
      <ThanksIcon className="w-72 h-72" />
      <h2 className="text-4xl text-neutral-400 font-semibold my-5">{title}</h2>
      <span className="text-text-gray text-lg">{subtitle}</span>
      <Link href="/app/orders">
        <div className="text-purple-300 mt-1 font-semibold text-lg cursor-pointer">
          <Badge
            bgClassName="bg-purple-50"
            textClassName="text-purple-300"
            text="Ver ordenes"
          />
        </div>
      </Link>
    </div>
  );
}

export default Thanks;
